import { Instance } from 'mobx-state-tree';
import { RouteActionDtoModelBase } from './RouteActionDtoModel.base';

/* The TypeScript type of an instance of RouteActionDtoModel */
export interface RouteActionDtoModelType extends Instance<typeof RouteActionDtoModel.Type> {}

/* A graphql query fragment builders for RouteActionDtoModel */
export { selectFromRouteActionDto, routeActionDtoModelPrimitives, RouteActionDtoModelSelector } from './RouteActionDtoModel.base';

/**
 * RouteActionDtoModel
 */
export const RouteActionDtoModel = RouteActionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
